import React, { useState } from "react";
import NProgress from "nprogress";
import { Button } from "../../Button";
import { User } from "@ecologi/shared";

import boxStyles from "../styles/ForestTitleBox.module.scss";
import styles from "../styles/ForestTitleEdit.module.scss";

interface Props {
  setEditModeState: (state: boolean) => void;
  profile: User;
  onEditTitle: (payload: any) => Promise<any>;
}

export const ForestTitleEdit: React.FC<Props> = (props) => {
  const { setEditModeState, profile } = props;

  const [name, setName] = useState("");
  const [isSaving, setSavingState] = useState(false);

  return (
    <form
      className={boxStyles.wrapper}
      data-edit-mode="true"
      onSubmit={async (e) => {
        e.preventDefault();
        NProgress.start();
        setSavingState(true);

        await props.onEditTitle({
          userId: profile.userId,
          fieldsToUpdate: {
            forestName: name,
          },
        });

        setSavingState(false);
        setEditModeState(false);
        NProgress.done();
      }}
    >
      <label className={styles.label}>
        Name your forest
        <input
          // eslint-disable-next-line
          autoFocus
          type="text"
          className={styles.input}
          placeholder="20 characters max."
          value={name}
          onChange={(e) => {
            const name = e.currentTarget.value;
            if (name.length <= 20) {
              setName(e.currentTarget.value);
            }
          }}
        />
        <span className={styles.count}>{name.length}/20</span>
      </label>
      <div className={styles.buttons}>
        <Button
          spruce
          small
          submit
          textOnly
          disabled={name.length === 0 || isSaving}
          text="Confirm name"
        />
        <Button
          textOnly
          small
          disabled={isSaving}
          onClick={(e) => {
            e.preventDefault();
            setEditModeState(false);
          }}
          text="Cancel"
        />
      </div>
    </form>
  );
};
